import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import cart from "./modules/cart";
import medien from "./modules/medien";
import search from "./modules/search";
import flashmessage from "./modules/flashmessage";
import photo from "./modules/photo";
import sampleglass from "./modules/sampleglass";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
    key: "optovision",
    storage: sessionStorage,
    modules: ["search"],
});

export default new Vuex.Store({
    modules: {
        cart,
        flashmessage,
        medien,
        search,
        photo,
        sampleglass,
    },
    plugins: [vuexPersist.plugin],
});
